import { Stack, Typography, Divider, Checkbox, FormControlLabel } from '@mui/material';
import { type LeadCaptureFormProps } from '@components/LeadCaptureForm/LeadCaptureForm.types';
import TextFieldLabel from '@shared/components/inputs/TextFieldLabel/TextFieldLabel';
import RadioGroupSet from '@shared/components/inputs/Radio/RadioGroupSet';
import { FormikTextField } from '@shared/components/inputs/FormikTextField';
import FormErrorMessage from '@shared/components/feedback/FormErrorMessage/FormErrorMessage';
import { BusinessInformationSection } from '@components/LeadCaptureForm/sections/BusinessInformationSection';
import { ContactInformationSection } from '@components/LeadCaptureForm/sections/ContactInformationSection';
import { ServiceAddressSection } from '@components/LeadCaptureForm/sections/ServiceAddressSection';
import { LeadSourceSection } from '@components/LeadCaptureForm/sections/LeadSourceSection';

const SERVICE_NEEDED_OPTIONS = [
  { value: 'INTERNET', label: 'Internet' },
  { value: 'TV', label: 'TV' },
  { value: 'PHONE', label: 'Phone' },
];

const LeadCaptureForm = ({ formik, contextMessage }: LeadCaptureFormProps) => {
  const { values, handleChange, touched, errors } = formik;

  return (
    <Stack gap="30px" p={{ xs: '20px', sm: '30px' }}>
      <Typography variant="body.emphasis" className="lead-capture-context-message">
        {contextMessage}
      </Typography>
      <Stack>
        <Typography variant="label.fieldSmall" className="lead-capture-customer-type-label">
          Customer Type
        </Typography>
        <RadioGroupSet
          row
          name="customerType"
          value={values.customerType}
          onChange={handleChange}
          options={[
            { value: 'RESIDENTIAL', label: 'Residential' },
            { value: 'BUSINESS', label: 'Business' },
          ]}
        />
        <Divider className="lead-capture-divider lead-capture-divider-spaced" />
      </Stack>
      <BusinessInformationSection formik={formik} />
      <ContactInformationSection formik={formik} />
      <Divider className="lead-capture-divider" />
      <ServiceAddressSection formik={formik} />
      <Divider className="lead-capture-divider" />
      <Typography variant="label.field" className="lead-capture-basic-service-label">
        Basic Service Request
      </Typography>
      <Stack gap="10px">
        <TextFieldLabel label="Type of Service Needed" />
        <Stack direction="row" gap="15px">
          {SERVICE_NEEDED_OPTIONS.map((option) => (
            <FormControlLabel
              key={option.value}
              control={
                <Checkbox
                  name="typeOfServiceNeeded"
                  value={option.value}
                  checked={values.typeOfServiceNeeded.includes(option.value)}
                  onChange={handleChange}
                />
              }
              label={option.label}
            />
          ))}
        </Stack>
        {errors.typeOfServiceNeeded && touched.typeOfServiceNeeded && (
          <FormErrorMessage>{errors.typeOfServiceNeeded as string}</FormErrorMessage>
        )}
      </Stack>
      <Divider className="lead-capture-divider" />
      <LeadSourceSection formik={formik} />
      <FormikTextField
        formik={formik}
        name="messageDetails"
        label="Message/Inquiry Details"
        optional
        multiline
        rows={8}
        className="lead-capture-multiline-input"
      />
    </Stack>
  );
};

export default LeadCaptureForm;
